import React from 'react'
import PropTypes from "prop-types";

function P2TextDescription(props) {
  return (
    <div className='polymer-text-description'>
      {typeof props.title == "string" && props.title && <p className='polymer-text-description__title' style={{color:props.color, fontSize:props.size}}>{props.title}{props.titleRequired && <span className='m-0 polymer-text-description__description-required'>*</span>}</p>}
      {typeof props.title == "object" && props.title && <div>{props.title}{props.titleRequired && <span className='m-0 polymer-text-description__description-required'>*</span>}</div>}
      {typeof props.description == "string" && props.description && <p className='polymer-text-description__description' style={{color:props.color, fontSize:props.description_size, margin: props.description_margin}}>
        {props.description}
        {props.required && <span className='m-0 polymer-text-description__description-required'>*</span>}
      </p>}
      {typeof props.description == "object" && props.description && <div className='polymer-text-description__description' style={{color:props.color, fontSize:props.description_size}}>
        {props.description}
      </div>}
    </div>
  )
}

export default P2TextDescription



P2TextDescription.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  description: PropTypes.oneOfType([PropTypes.string,PropTypes.node]),
  color: PropTypes.string,
  size: PropTypes.string,
  description_size: PropTypes.string,
  description_margin: PropTypes.string,
  required: PropTypes.bool,
  titleRequired: PropTypes.bool,
}


P2TextDescription.defaultProps = {
  required:false,
  titleRequired:false,
};